(function() {
  var currentPlan = 'spray';
  var surveyAnswers = { frequence: '', ressenti: '', wtp: '' };

  // ── PRICING TIERS ────────────────────────────────────────────────────────
  var TIER1_MAX = 20;
  var TIER2_MAX = 50;

  var TIERS = {
    tier1: { sprayPrice: '7,99€', kitPrice: '22,99€', sprayOrig: '15,98€', kitOrig: '45,00€', discount: '-50%', label: '🔥 Prix lancement' },
    tier2: { sprayPrice: '11,19€', kitPrice: '31,50€', sprayOrig: '15,98€', kitOrig: '45,00€', discount: '-30%', label: '⚡ Prix early' },
    normal: { sprayPrice: '15,98€', kitPrice: '45,00€', sprayOrig: '', kitOrig: '', discount: '', label: '' }
  };

  function getCount() {
    return parseInt(localStorage.getItem('riderrr_signups') || '0');
  }

  function getCurrentTier() {
    var c = getCount();
    if (c < TIER1_MAX) return 'tier1';
    if (c < TIER2_MAX) return 'tier2';
    return 'normal';
  }

  function updateCounter() {
    var c = getCount();
    var tier = getCurrentTier();
    var wrapper = document.getElementById('places-counter');
    var countEl = document.getElementById('places-count');

    if (tier === 'tier1' && wrapper) {
      var rem = TIER1_MAX - c;
      if (countEl) countEl.textContent = rem;
      wrapper.style.display = 'block';
    } else if (tier === 'tier2' && wrapper) {
      var rem2 = TIER2_MAX - c;
      wrapper.innerHTML = '<span style="font-size:12px;letter-spacing:0.1em;text-transform:uppercase;">⚡ Il reste <span style="font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:#e67e22;">' + rem2 + '</span> places early (-30%)</span>';
      wrapper.style.display = 'block';
    } else if (wrapper) {
      wrapper.style.display = 'none';
    }
  }

  function selectPlan(plan) {
    currentPlan = plan;
    // Coche le bon radio button pour que le sticky puisse le lire
    var radio = document.querySelector('#card-' + plan + ' input[type="radio"]');
    if (radio) radio.checked = true;
    swapHeroImage(plan);
    document.querySelectorAll('.price-card').forEach(function(c) {
      c.style.cssText = 'flex:1;min-width:150px;border:1.5px solid #e0deda;padding:18px;cursor:pointer;position:relative;background:#fafaf8;box-sizing:border-box;';
    });
    var selected = document.getElementById('card-' + plan);
    if (selected) {
      selected.style.cssText = 'flex:1;min-width:150px;border:2px solid #0a0a0a;padding:18px;cursor:pointer;position:relative;background:#f2f1ee;box-sizing:border-box;';
    }
    var tier = getCurrentTier();
    var prices = TIERS[tier];
    var price = plan === 'kit' ? prices.kitPrice : prices.sprayPrice;
    var priceEl = document.getElementById('cta-price');
    if (priceEl) priceEl.textContent = price;
    var priceBot = document.getElementById('cta-price-bottom');
    if (priceBot) priceBot.textContent = price;
    if (typeof gtag !== 'undefined') gtag('event', 'select_plan', { plan: plan });
  }

  function subscribeToKlaviyo(email, phone, plan, price) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Y7nHuj', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Riderrr Landing Page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  phone_number: phone || null,
                  properties: {
                    plan_choisi: plan,
                    prix: price,
                    source: 'riderrr_landing',
                    survey_frequence: surveyAnswers.frequence,
                    survey_ressenti: surveyAnswers.ressenti,
                    survey_wtp: surveyAnswers.wtp
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: 'XK8D56' } } }
        }
      })
    })
    .then(function(r) {
      console.log('Klaviyo:', r.status);
      if (!r.ok) r.text().then(function(t) { console.error('Klaviyo error:', t); });
    })
    .catch(function(e) { console.error('Klaviyo error:', e); });
  }


  function goToProduct() {
    var url = currentPlan === 'kit' ? '/products/riderrr-hair-styler-kit-complet' : '/products/riderrr-hair-styler';
    if (typeof gtag !== 'undefined') gtag('event', 'click_buy', { plan: currentPlan });
    if (typeof fbq !== 'undefined') fbq('track', 'InitiateCheckout', { content_name: currentPlan });
    window.location.href = url;
  }


  function swapHeroImage(plan) {
    var heroImg = document.querySelector('.hero-photo img');
    if (!heroImg) return;
    var newSrc = plan === 'kit'
      ? 'https://cdn.shopify.com/s/files/1/1046/0879/2908/files/Kit_motard_Picture_opt.webp?v=1778014911'
      : 'https://cdn.shopify.com/s/files/1/1046/0879/2908/files/hero-mobile.webp?v=1778014145';
    heroImg.style.opacity = '0';
    heroImg.style.transition = 'opacity 0.3s ease';
    setTimeout(function() {
      // Clear srcset so src takes over
      heroImg.removeAttribute('srcset');
      heroImg.removeAttribute('sizes');
      heroImg.src = newSrc;
      heroImg.style.opacity = '1';
    }, 300);
  }

  function init() {
    // Price cards
    var sprayCard = document.getElementById('card-spray');
    var kitCard = document.getElementById('card-kit');

    if (sprayCard) {
      sprayCard.style.cssText = 'flex:1;min-width:150px;border:2px solid #0a0a0a;padding:18px;cursor:pointer;position:relative;background:#f2f1ee;box-sizing:border-box;';
      sprayCard.addEventListener('click', function(e) { selectPlan('spray'); });
    }
    if (kitCard) {
      kitCard.style.cssText = 'flex:1;min-width:150px;border:1.5px solid #e0deda;padding:18px;cursor:pointer;position:relative;background:#fafaf8;box-sizing:border-box;';
      kitCard.addEventListener('click', function(e) { selectPlan('kit'); });
    }

    // CTA scroll
    var ctaBtn = document.querySelector('.cta-btn');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof gtag !== 'undefined') gtag('event', 'click_cta');
        window.location.href = currentPlan === 'kit' ? '/products/riderrr-hair-styler-kit-complet' : '/products/riderrr-hair-styler';
      });
    }

    // Survey options — completely isolated click handlers
    document.querySelectorAll('.survey-opt').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var q = btn.getAttribute('data-q');
        var v = btn.getAttribute('data-v');
        if (q && v) {
          surveyAnswers[q] = v;
          if (typeof gtag !== 'undefined') gtag('event', 'survey_answer', { question: q, answer: v });
        }
        // Reset siblings
        var siblings = btn.parentElement.querySelectorAll('.survey-opt');
        siblings.forEach(function(s) {
          s.classList.remove('active');
          s.setAttribute('style', 'background:transparent;color:#0a0a0a;border:1.5px solid #e0deda;padding:9px 18px;font-size:13px;font-weight:300;cursor:pointer;font-family:inherit;');
        });
        // Activate clicked
        btn.classList.add('active');
        btn.setAttribute('style', 'background:#0a0a0a;color:#fafaf8;border:1.5px solid #0a0a0a;padding:9px 18px;font-size:13px;font-weight:300;cursor:pointer;font-family:inherit;');
      });
    });

    // Main form submit
    var form = document.getElementById('riderrr-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var emailInput = document.getElementById('riderrr-email');
        var phoneInput = document.getElementById('riderrr-phone');
        var email = emailInput ? emailInput.value.trim() : '';
        var phone = phoneInput ? phoneInput.value.trim() : '';
        if (!email) return;

        var tier = getCurrentTier();
        var prices = TIERS[tier];
        var price = currentPlan === 'kit' ? prices.kitPrice : prices.sprayPrice;
        var btn = form.querySelector('.final-btn');

        subscribeToKlaviyo(email, phone, currentPlan, price);

        // Increment counter
        var newCount = getCount() + 1;
        localStorage.setItem('riderrr_signups', newCount);
        updateCounter();

        if (typeof gtag !== 'undefined') {
          gtag('event', 'form_submit', { plan: currentPlan, has_phone: phone ? 'yes' : 'no', survey_wtp: surveyAnswers.wtp });
        }
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', { content_name: currentPlan, currency: 'EUR', value: parseFloat(price) });
        }

        if (btn) { btn.textContent = 'Coupon envoyé ✓'; btn.style.opacity = '0.7'; }
        if (emailInput) emailInput.value = '';
        if (phoneInput) phoneInput.value = '';

        var note = document.getElementById('riderrr-note');
        if (note) {
          note.innerHTML = '✓ Coupon -30% envoyé à ' + email + ' — vérifie ta boîte mail 🎉';
          note.style.color = '#3B6D11';
          note.style.fontWeight = '500';
        }
        setTimeout(function() { if (btn) { btn.textContent = 'Je rejoins'; btn.style.opacity = '1'; } }, 5000);
      });
    }

    // Contact form
    var contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var name = '';
        var email = document.getElementById('contact-email').value.trim();
        var message = document.getElementById('contact-message').value.trim();
        if (!email || !message) return;
        var btn = document.getElementById('contact-btn');
        var note = document.getElementById('contact-note');
        if (btn) btn.textContent = 'Envoyé ✓';
        if (note) { note.textContent = 'Message reçu — on revient vers toi dans les 24h.'; note.style.color = '#3B6D11'; }
        contactForm.reset();
        setTimeout(function() { if (btn) btn.textContent = 'Envoyer'; }, 4000);
      });
    }

    // Init counter on load
    updateCounter();
  }

  // Expose globally
  window.selectPlan = selectPlan;
  window.getCurrentPlan = function() { return currentPlan; };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
